export const supportQueryKeys = {
  themes: ['support', 'themes'] as const,
  branches: ['support', 'branches'] as const,
  storeTypes: ['support', 'store-types'] as const,
};
